import { useTracker, useUBLContext, ZigzagEvent } from '@common/log-manager';

const getUrl = () => {
  return typeof window !== 'undefined' ? window.location.href : null;
};

export const useShippingUBL = () => {
  const tracker = useTracker();
  const ublContext = useUBLContext();

  const shippingInfoClickUBL = (catalog_product_id: string) => {
    tracker.addLog({
      category: 'click',
      navigation: ublContext.navigation ? ublContext.navigation : 'product_detail',
      navigation_sub: {
        page_url: getUrl(),
      },
      object_type: 'button',
      object_id: 'shipping_info',
      data: { catalog_product_id },
    });
  };

  const shippingNoticeBannerClickUBL = () => {
    ZigzagEvent.subl({
      navigation: ublContext.navigation ? ublContext.navigation : 'product_detail',
      category: 'click',
      object_type: 'banner',
      object_id: 'delivery_notice',
    });
  };

  const shippingDefaultAddressClickUBL = () => {
    ZigzagEvent.subl({
      navigation: ublContext.navigation ? ublContext.navigation : 'product_detail',
      category: 'click',
      object_section: 'shipping_info',
      object_type: 'button',
      object_id: 'add_shipping_address',
    });
  };
  const shippingDefaultAddressImpressionUBL = () => {
    ZigzagEvent.subl({
      navigation: ublContext.navigation ? ublContext.navigation : 'product_detail',
      category: 'impression',
      object_section: 'shipping_info',
      object_type: 'button',
      object_id: 'add_shipping_address',
    });
  };

  return {
    shippingInfoClickUBL,
    shippingNoticeBannerClickUBL,
    shippingDefaultAddressClickUBL,
    shippingDefaultAddressImpressionUBL,
  };
};
